import React from 'react';
import { Modal } from 'react-bootstrap';
import { onChangeDarkMode, Onopenmodalsetting, onChangeHighcontrast, onChangeTheme } from '../../Redux/Actions/Action';
import { connect } from 'react-redux';

function AddModal(props) {
    const { darkMode, openmodal, highcontrast, theme } = props.Mainreducer

    return (
        <Modal className="modal fade right " id="Settingmodal" show={openmodal} onHide={() => { props.Onopenmodalsetting(false) }}>
            <div className="modal-content">
                <Modal.Header className="modal-header" closeButton>
                    <Modal.Title>
                        <h5 className="modal-title">Custom Settings</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-body custom_setting">
                    <div className="setting-mode py-3">
                        <h6 className="card-title mb-2 fs-6 d-flex align-items-center"><i className="icofont-layout fs-4 me-2 text-primary"></i>Layout Settings</h6>
                        <ul className="list-group list-unstyled mb-0 mt-1">
                            <li className="list-group-item d-flex align-items-center py-1 px-2">
                                <div className="form-check form-switch theme-switch mb-0">
                                    <input className="form-check-input" type="checkbox" id="theme-switch" checked={darkMode === 'dark'} onChange={() => { props.onChangeDarkMode(darkMode === 'dark' ? 'light' : 'dark') }} />
                                    <label className="form-check-label" htmlFor="theme-switch">Enable Dark Mode!</label>
                                </div>
                            </li>
                            <li className="list-group-item d-flex align-items-center py-1 px-2">
                                <div className="form-check form-switch theme-high-contrast mb-0">
                                    <input className="form-check-input" type="checkbox" id="theme-high-contrast" checked={highcontrast === 'high-contrast'} onChange={() => { props.onChangeHighcontrast(highcontrast === 'high-contrast' ? 'light' : 'high-contrast') }} />
                                    <label className="form-check-label" htmlFor="theme-high-contrast">Enable High Contrast</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                </Modal.Body>
                <Modal.Footer className="modal-footer justify-content-start">
                    <button type="button" className="btn btn-white border lift" onClick={() => { props.Onopenmodalsetting(false) }}>Close</button>
                </Modal.Footer>
            </div>
        </Modal>
    )
}

const mapStateToProps = ({ Mainreducer }) => ({
    Mainreducer
})

export default connect(mapStateToProps, {
    onChangeDarkMode,
    Onopenmodalsetting,
    onChangeHighcontrast,
    onChangeTheme
})(AddModal)